import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Truck, ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatError } from "../../lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) { toast.error("Enter email and password"); return; }
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/portal");
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1600352707011-ec0c3bcb145f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNvbnRhaW5lcnMlMjBkZWxpdmVyeSUyMHRydWNrJTIwY2FyZ28lMjBzaGlwfGVufDB8fHx8MTc3NjU5NDQ2Mnww&ixlib=rb-4.1.0&q=85" alt="Logistics" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1A1A1A]/80 via-[#1A1A1A]/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <div className="w-12 h-12 rounded-lg bg-[#DC2A1C] grid place-items-center mb-4"><Truck className="w-6 h-6" strokeWidth={2.5} /></div>
          <div className="text-3xl font-black tracking-tight">Translog Express</div>
          <div className="text-sm text-white/70 mt-2 max-w-md">Secure employee and admin portal. Manage agents, documents, news and holidays in one place.</div>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-16 bg-white">
        <div className="w-full max-w-md">
          <div className="flex items-center justify-between mb-8">
            <img src="/assets/TRANSLOG SECONDARY LOGO.png" alt="Translog Express Pvt. Ltd." className="h-14 w-auto object-contain" data-testid="login-header-logo" />
            <Link to="/" className="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-[#DC2A1C]" data-testid="back-home-link">
              <ArrowLeft className="w-4 h-4" /> Back to site
            </Link>
          </div>
          <div className="text-xs uppercase tracking-[0.2em] text-[#DC2A1C] font-semibold mb-2">Employee Portal</div>
          <h1 className="text-3xl font-black tracking-tight mb-8">Sign in to your account</h1>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-gray-600 mb-2">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#F8F9FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:border-[#DC2A1C]" placeholder="you@translogexpress.com" data-testid="login-email" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-gray-600 mb-2">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#F8F9FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:border-[#DC2A1C]" placeholder="••••••••" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="tl-btn w-full disabled:opacity-60" data-testid="login-submit">
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          <p className="text-xs text-gray-500 mt-8">Need access? Contact your administrator.</p>

          <div className="mt-10 pt-6 border-t border-gray-100 flex justify-center">
            <img src="/assets/logo_footer_1.png" alt="Translog Express Pvt. Ltd." className="h-24 w-auto object-contain" data-testid="login-footer-logo" />
          </div>
        </div>
      </div>
    </div>
  );
}
